import type { Block } from "../../types";
import { PublicationBlockCard } from "./PublicationBlockCard";
import { MediaBlockCard } from "./MediaBlockCard";
import { NoteBlockCard } from "./NoteBlockCard";
import "./blocks.css";

type BlockGridProps = {
	blocks: Block[];
};

/** Mosaico responsivo; escolhe o cartão pelo `kind` de cada bloco. */
export function BlockGrid({ blocks }: BlockGridProps) {
	return (
		<div className="block-grid">
			{blocks.map((block) => (
				<BlockCard block={block} key={block.id} />
			))}
		</div>
	);
}

function BlockCard({ block }: { block: Block }) {
	switch (block.kind) {
		case "publication":
			return <PublicationBlockCard block={block} />;
		case "media":
			return <MediaBlockCard block={block} />;
		case "note":
			return <NoteBlockCard block={block} />;
	}
}
